import { INITIAL_PARTNER_DATA } from '../constants.js';

export const createUpdateFormData = (setFormData) => (field, value) => {
    if (field?.includes('.')) {
        const [parent, child] = field.split('.');
        setFormData((prev) => ({
            ...prev,
            [parent]: {
                ...(prev[parent] || {}),
                [child]: value,
            },
        }));
    } else {
        setFormData((prev) => ({
            ...prev,
            [field]: value,
        }));
    }
};

export const createUpdateMultipleFields = (setFormData) => (updates) => {
    setFormData((prev) => ({
        ...prev,
        ...updates,
    }));
};

export const createResetForm =
    (setFormData, initialData = {}) =>
    () => {
        setFormData({
            ...INITIAL_PARTNER_DATA,
            ...initialData,
        });
    };

export const getInitialFormData = (initialData = {}) => {
    const data = {
        ...INITIAL_PARTNER_DATA,
        ...initialData,
    };
    
    // Ensure partnerBillingSettings is an object if it's null
    if (!data.partnerBillingSettings) {
        data.partnerBillingSettings = {};
    }
    
    return data;
};

// Transform formData for create partner API - only send required fields
export const transformFormDataForCreate = (formData) => {
    const createData = {
        isActive: formData.isActive ?? true,
        wholesalerID: formData.wholesalerID,
        mode: formData.mode || 'light',
        name: formData.name,
        entityName: formData.entityName,
        defaultPartnerPlanID: formData.defaultPartnerPlanID,
        trunkLocationID: formData.trunkLocationID || 'MEL',
        enabled: formData.enabled ?? true,
    };

    // Add hostHeader if provided
    if (formData.hostHeader) {
        createData.hostHeader = formData.hostHeader;
    }

    console.log('=== Transform Form Data for Create ===');
    console.log('Original formData:', formData);
    console.log('Transformed createData:', createData);

    return createData;
};

// Transform formData for update partner API
export const transformFormDataForUpdate = (formData) => {
    // For update, send the full formData as the API expects nested objects
    return formData;
};
